module.exports = __webpack_public_path__ + "static/media/TUNE_5211.22691d46.jpg";